import React from "react";

const HeartIcon = () => {
    return (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.50098 11.1563C6.50098 11.1563 0.641602 7.875 0.641602 3.89063C0.641721 3.18641 0.885734 2.50397 1.33216 1.95933C1.77858 1.41469 2.39985 1.04148 3.09035 0.903134C3.78084 0.764793 4.49794 0.869868 5.11972 1.20049C5.7415 1.53112 6.22958 2.06688 6.50098 2.7167L6.50097 2.71671C6.77237 2.06689 7.26045 1.53112 7.88223 1.20049C8.50401 0.869869 9.22111 0.764794 9.91161 0.903134C10.6021 1.04147 11.2234 1.41469 11.6698 1.95933C12.1162 2.50397 12.3602 3.18641 12.3604 3.89063C12.3604 7.875 6.50098 11.1563 6.50098 11.1563Z" stroke="#51BCEC" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}


export {
    HeartIcon
}